
const WhatsAppButton = () => {
  return (
    <a
      href="https://wa.me/27798768956"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 bg-primary text-white rounded-full shadow-lg hover:bg-primary-dark transition-all hover:scale-110 z-50 cursor-pointer w-16 h-16 flex items-center justify-center"
      aria-label="Contact us on WhatsApp"
    >
      <i className="ri-whatsapp-line text-3xl w-8 h-8 flex items-center justify-center"></i>
    </a>
  );
};

export default WhatsAppButton;
